import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

//  Request Interceptor
API.interceptors.request.use(
  (config) => {
    if (typeof navigator !== "undefined" && !navigator.onLine) {
      return Promise.reject({
        message: "No internet connection",
        isOffline: true,
      });
    }

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Response Interceptor
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;

    // Timeout
    if (error.code === "ECONNABORTED") {
      return Promise.reject({
        message: "Request timeout. Please try again.",
        status: 408,
      });
    }

    // Auth errors
    if (status === 401 || status === 403) {
      localStorage.clear();

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    // Retry for network/server issues
    if (!error.response || status >= 500) {
      const config = error.config;

      if (!config || config.__retryCount >= 2) {
        return Promise.reject({
          message: "Server unreachable. Try again later.",
        });
      }

      config.__retryCount = config.__retryCount || 0;
      config.__retryCount++;

      return API(config);
    }

    // Normalized error
    return Promise.reject({
      message:
        error.response?.data?.message || "Something went wrong",
      status,
    });
  }
);

export default API;